<template>
  <SMListTemplate prefix="Tanımlar" title="Kampanya Listesi">
    <template #actions>
      <div class="d-flex align-items-center">
        <v-icon
          v-permission="{
            permissions: ['campaigns-delete'],
          }"
          color="error cursor-pointer"
          dark
          :disabled="!hasCampaign"
          class="mr-2"
          @click="showDeleteCampaignModal"
        >
          mdi-delete
        </v-icon>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="cursor-pointer"
              dark
              @click="() => fetchCampaigns()"
              v-bind="attrs"
              v-on="on"
            >
              mdi-reload
            </v-icon>
          </template>
          <span>Yenile</span>
        </v-tooltip>
        <v-text-field
          v-model="search"
          label="Ara"
          dark
          class="mx-4 mt-0 pt-0"
          hide-details="auto"
          single-line
          append-icon="search"
        ></v-text-field>
        <router-link
          :to="{ name: 'def-campaigns-edit', query: { editable: true } }"
        >
          <v-btn
            v-permission="{
              permissions: ['campaigns-create'],
            }"
            elevation="0"
            color="success"
          >
            <v-icon small>mdi-plus</v-icon>
            Yeni Kampanya
          </v-btn>
        </router-link>
      </div>
    </template>
    <template #table>
      <v-data-table
        v-model="selectedCampaign"
        :headers="headers"
        :items="campaigns"
        :search="search"
        :single-select="true"
        sort-by="system"
        :loading="loading"
        sort-desc="true"
        :items-per-page="100"
        show-select
        item-key="id"
      >
        <template #item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <router-link
                :to="{
                  name: 'def-campaigns-edit',
                  params: { id: item.id },
                  query: { editable: true },
                }"
              >
                <v-icon
                  color="warning"
                  small
                  v-permission="{
                    permissions: ['campaigns-update'],
                  }"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </router-link>
            </template>
            <span>Düzenle</span>
          </v-tooltip>
        </template>
        <template #item.name="{ item }">
          <router-link
            v-permission="{
              permissions: ['campaigns-read'],
            }"
            :to="{
              name: 'def-campaigns-edit',

              params: { id: item.id },
              query: { editable: false },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>
        <template #item.channel_id="{ item }">
          <router-link
            :to="{
              name: 'def-channels-edit',
              params: { id: item.channel_id },
              query: { editable: false },
            }"
          >
            {{ item.channel ? item.channel.name : "" }}
          </router-link>
        </template>
        <template #item.url="{ item }">
          <a :href="item.url" target="_blank">{{ item.url }}</a>
        </template>
        <template #item.description="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{
                  item.description.length > 35
                    ? item.description.substring(0, 35) + " ..."
                    : item.description
                }}
              </span>
            </template>
            <span>{{ item.description }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>
  </SMListTemplate>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  FETCH_CAMPAIGNS,
  DELETE_CAMPAIGN,
} from "@/core/services/store/definitions/campaigns.module";
import SMListTemplate from "@/view/content/components/SMListTemplate.vue";

export default {
  data() {
    return {
      headers: [
        { value: "name", text: "İsim", sortable: false, align: "left" },
        { value: "channel_id", text: "Kanal", sortable: false, align: "left" },
        { value: "code", text: "Kod", sortable: false, align: "left" },
        {
          value: "description",
          text: "Açıklama",
          sortable: false,
          align: "left",
        },
        { value: "url", text: "URL", sortable: false, align: "left" },
        {
          value: "actions",
          text: "",
          sortable: false,
          align: "left",
        },
        { text: "", value: "data-table-select", align: "right" },
      ],
      selectedCampaign: [],
      search: "",
      loading: true,
    };
  },
  components: { SMListTemplate },
  mounted() {
    this.fetchCampaigns().then(() => (this.loading = false));
  },
  methods: {
    ...mapActions([FETCH_CAMPAIGNS, DELETE_CAMPAIGN]),
    async campaignDelete() {
      try {
        await this.deleteCampaign(this.selectedCampaign[0]);
        this.$toast.success("Kampanya silindi", {
          position: "bottom-right",
          duration: 2000,
        });
        this.selectedCampaign = [];
      } catch (error) {
        const message =
          error[0].code === "QueryException"
            ? "Bu kampanya bir lead ile ilişkili olduğu için silinemez."
            : error[0].detail;
        this.$toast.error(message, {
          position: "bottom-right",
          duration: 2000,
        });
      }
    },
    showDeleteCampaignModal() {
      const params = {
        title: "Seçtiğiniz kampanya silinecek",
        text: "Seçili kampanyayı silmek istediğinize emin misiniz?",
        onConfirm: () => {
          return this.campaignDelete();
        },
      };
      this.$approvalModal.show(params);
    },
  },
  computed: {
    ...mapGetters(["campaigns"]),
    hasCampaign() {
      return this.selectedCampaign.length === 1;
    },
  },
};
</script>

<style></style>
